import React from "react";

const cvItemDetail = (props) => {
  let prefixSign = "> ";
  if (!props.primary) {
    prefixSign = " -- ";
  }

  let itemCls = "cv-details__item";
  if (props.bold) {
    itemCls = "cv-details__item bold";
  }

  return (
    <div className={itemCls}>
      {prefixSign}
      {props.children}
    </div>
  );
};

cvItemDetail.defaultProps = {
  cvItemType: "Detail"
};

export default cvItemDetail;
